import React from 'react'
import Moment from 'react-moment'
import { Icon, Popup } from 'semantic-ui-react'
import { upper } from 'change-case'
import { StatusTag } from 'components'
import { numberFormat } from 'core/utilities'
import { TableCell, PriorityTag } from './styled'
import { purchaseRequisitionDetailPath as prDetailPath, 
  requestForQuotationDetailPath as rfqDetailPath } from 'routes'
  import * as v from 'variables/styles'

export const poListColumns = [
  {
    Header: '',
    accessor: 'isSpecialCreditTerm',
    width: 30,
    Cell:row=>(row.value&&<Icon name='star' color='yellow'/>)
  },
  {
    Header: 'Status',
    accessor: 'status',
    className: 'center',
    width: 100,
    Cell: row => (<StatusTag status={row.value} statusName={row.original.statusName} />)
  },
  {
    Header: 'Doc No.',
    accessor: 'documentNumber',
    width: 100,
  },
  {
    Header: 'PO No.',
    accessor: 'poSapNumber',
    width: 100,
  },
  {
    Header: 'PO Version',
    accessor: 'printVersion',
    Cell: row => (`${ row.value != null ? `${row.value}` : '-'}`),
    className:'center'
  },
  {
    Header: 'RFQ No.',
    accessor: 'rfqNumber',
    width: 100,
  },
  {
    Header: 'Title',
    accessor: 'title',
    headerClassName: 'left',
    width: 250,
  },
  {
    Header: 'Project Name',
    accessor: 'projectName',
    width: 100,
  },
  {
    Header: 'Vendor',
    accessor: 'vendorName',
    width: 120,
  },
  {
    Header: 'Company',
    accessor: 'companyName',
    width: 120,
  },
  {
    Header: 'Activity',
    accessor: 'statusActivity',
  },
  {
    Header: 'Priority',
    accessor: 'priority',
    width: 70,
    Cell: row => <TableCell center><PriorityTag className={`priority ${row.value}`}>{upper(row.value)}</PriorityTag></TableCell>
  },
  {
    Header: 'Requester',
    accessor: 'requesterName',
  },
  {
    Header: 'SLA Status',
    accessor: 'slaStatus',
    show: false,
    Cell: row => {
      let overdue = row.original.pendingDays - row.original.slaDays
      return <div style={{ color: 'red' }}>{overdue > 0 ? 'Overdue' : ''}</div>
    }
  },
  {
    Header: 'SLA Remaining',
    id:'overdue',
    show: false,
    accessor : row =>(Math.floor(row.pendingDays-row.slaDays)),
    Cell: row => (<div>{`${ row.value >= 1 ? `(${row.value} days)` : '-'}`}</div>)
  },
  {
    Header: 'Submitted date',
    accessor: 'submittedDate',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY hh:mm'>{row.value}</Moment> : null)
  },
  {
    Header: 'Modified date',
    accessor: 'modifiedDate',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY hh:mm'>{row.value}</Moment> : null)
  },
]

const linkStyle = {
  color: v.ezMainColor,
  fontWeight: 'bold',
  textDecoration: 'underline',
  cursor: 'pointer',
}

export const poItemColumns = [
  {
    Header: 'PR',
    accessor: 'prNo',
    width: 85,
    resizable: false,
    Cell: row => <div style={linkStyle} onClick={() => window.open(prDetailPath(row.original.prId), '_blank')} >{row.value}</div>
  },
  {
    Header: 'RFQ',
    width: 90,
    accessor: 'rfqNo',
    resizable: false,
    Cell: row => <div style={linkStyle} onClick={() => window.open(rfqDetailPath(row.original.rfqId), '_blank')} >{row.value}</div>
  },
  {
    Header: 'No',
    accessor: 'lineNo',
    className: 'center',
    width: 35,
    resizable: false,
  },
  {
    Header: 'Material No.',
    accessor: 'materialNo',
    width: 80,
    resizable: false,
    Cell: row => (row.value || '').removeLeadingZero()
  },
  {
    Header: 'Item Name',
    accessor: 'itemName',
    width: 240,
    resizable: false,
    className: 'poItemName',
  },
  {
    Header: 'Description',
    accessor: 'remark',
    width: 200,
    Cell: row => <Popup content={row.value} basic hoverable trigger={<span className='rt-td'>{row.value}</span>} />
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
    className: 'right',
    width: 75,
    resizable: false,
    Cell: row => numberFormat(row.value, true),
  },
  {
    Header: 'Unit',
    accessor: 'unitName',
    width: 75
  },
  {
    Header: 'Unit Price',
    accessor: 'unitPrice',
    className: 'right',
    width: 80,
    resizable: false,
    Cell: row => numberFormat(row.value, true),
  },
  {
    Header: 'Amount',
    accessor: 'sapAmount',
    className: 'right',
    width: 100,
    resizable: false,
    Cell: row => numberFormat(row.value, true),
  },
  {
    Header: 'Vat Amount',
    accessor: 'vatTotalAmount',
    className: 'right',
    width: 80,
    resizable: false,
    Cell: row => numberFormat(row.value, true),
  },
  {
    Header: 'Currency',
    accessor: 'currency',
    width: 60,
    resizable: false,
    className: 'center itemCurrency',
  },
]